/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReorderRestaurantQueryVariables = Exact<{
  id: string | number;
}>;

export type ReorderRestaurantQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly slug: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly phone: string;
    readonly flexMessage: string | null;
    readonly isAcceptingOrders: boolean;
    readonly notAcceptingOrdersReason: string;
    readonly hours: { readonly formatted: string | null };
    readonly asset: { readonly url: string };
  } | null;
};

export type ReorderRestaurantRequiredDataFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly name: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly slug: string;
  readonly address: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly isOutpost: boolean;
  readonly phone: string;
  readonly flexMessage: string | null;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly hours: { readonly formatted: string | null };
  readonly asset: { readonly url: string };
};

export const ReorderRestaurantRequiredDataFragmentDoc = gql`
  fragment ReorderRestaurantRequiredData on Restaurant {
    id
    __typename
    name
    latitude
    longitude
    slug
    address
    city
    state
    zipCode
    isOutpost
    phone
    hours {
      formatted
    }
    flexMessage
    isAcceptingOrders
    notAcceptingOrdersReason
    asset {
      url
    }
  }
`;
export const ReorderRestaurantDocument = gql`
  query ReorderRestaurant($id: ID!) {
    restaurant(id: $id) {
      ...ReorderRestaurantRequiredData
    }
  }
  ${ReorderRestaurantRequiredDataFragmentDoc}
`;

export function useReorderRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ReorderRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderRestaurantQuery, ReorderRestaurantQueryVariables>({
    query: ReorderRestaurantDocument,
    ...options,
  });
}
